shadow$provide[135] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Guard:{enumerable:true, get:function() {
  return Guard;
}}});
class Guard {
  constructor(limit) {
    if (limit == null) {
      limit = 10;
    }
    this.limit = limit;
  }
  iterate(options) {
    const {step, last} = options;
    let {limit} = this;
    while (step()) {
      if (!--limit) {
        console.warn("Last iteration", typeof last === "function" ? last() : undefined);
        throw new Error("Exceeded iteration limit.");
      }
    }
    return null;
  }
}

};